class Slideshowpro extends HTMLElement {
  constructor() {
    super();

    this.Slide = this.querySelector('.js-slideshow-pro');
    new Swiper(this.Slide, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        pagination: {
          el: ".swiper-pagination-custom",
          clickable: true,
        },
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next-custom',
          prevEl: '.swiper-button-prev-custom',
        },
    });
  }
}
customElements.define("slideshow-pro-component", Slideshowpro);